import * as React from 'react';
import styles from './style.scss';
import CSSModules from "react-css-modules";
import ReactModal from 'react-modal';
import PropTypes from "prop-types";

@CSSModules(styles, {allowMultiple: true})
export class MySunbitBanner extends React.Component {

  static propTypes = {
    applyClicked: PropTypes.func.isRequired,
    smallHeader: PropTypes.string.isRequired,
    header: PropTypes.node.isRequired,
    imgSrc: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isOpen : PropTypes.bool.isRequired,
    isImgFit: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    const {smallHeader, header, buttonText, imgSrc, note} = this.props;
    return(
      <ReactModal isOpen={this.props.isOpen}
                  ariaHideApp={false}
                  style={{
                    overlay: {background: 'rgba(17, 28, 53, 0.5)'},
                    content: {
                      textAlign: 'center', top: '50%', left: '50%', right: 'auto', bottom: 'auto',
                      transform: 'translate(-50%, -50%)', borderRadius: '25px', padding: 0
                    }
                  }}>
    <div styleName="container" data-at={`${this.props.name}-big-modal`}>
      <div styleName="close">
        <img styleName="cardImg" src={'/static/images/close24px.png'} onClick={this.props.onExit} data-at={`${this.props.name}-modal-close`}/>
      </div>
      <div styleName="body">
        <div styleName="imgContainer">
          <img styleName={this.props.isImgFit ? 'cardImgFit' : 'cardImg'} src={imgSrc} alt={`${this.props.name} banner image`}/>
        </div>
        <div styleName="description">
          <div styleName="descriptionHeader" data-at={`${this.props.name}-limited-header`}>{smallHeader}</div>
          <div styleName="descriptionBody" data-at={`${this.props.name}-modal-desc-header`}>{header}</div>
          {this.state.width <= 980 && <div
            styleName="smallScreenText" data-at={`${this.props.name}-tab-bank`}>{note}</div>}
          <div styleName="applyNowButtonContainer">
            <button styleName="applyNowButton" data-at={`${this.props.name}-modal-apply`} onClick={this.props.applyClicked}>{buttonText}</button>
          </div>
        </div>
      </div>
      {this.state.width > 980 && <div data-at={`${this.props.name}-tab-bank`}
        styleName="smallText">{note}</div>}
    </div>
      </ReactModal>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/banners/MySunbitBanner/mySunbitBanner.js